import Vue from 'vue'
import NotFound from 'vue'
import VueRouter from 'vue-router'
import Callback from '../views/callback.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/callback',
    component: Callback,
  },
  {
    path: '*',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
